import "./accessibility.js"
import "./analyticsTracking.js"

import(/* webpackChunkName: "styleBundleCritical" */ "../styles/styleBundleCritical.scss");
import(/* webpackChunkName: "styleBundle1" */ "../styles/styleBundle1.scss");
import(/* webpackChunkName: "styleBundle2" */ "../styles/styleBundle2.scss");
import(/* webpackChunkName: "styleBundle3" */ "../styles/styleBundle3.scss");

import("./searchBox.js");
import("./navigationKeyboard.js");
import("./languageSelection.js");
import("./mobileNavigation.js");
import("./mobileNavSearchBox.js");
import("./mobileNavLanguage.js");
import("./navbarScrollEffect.js");

if (document.querySelector(".adm-div-c5-results-page")) {
    import("./filterSearchResults.js");
    import("./searchBoxResultsPage.js");
}

if (document.querySelector(".adm-section-c6-hero-banner")) {
    import("./heroCarousel.js");
}

if (document.querySelector(".adm-btn-c6v2-jump")) {
    import("./hubHero.js");
}

if (document.querySelector(".adm-section-accordion")) {
    import("./accordion.js");
}

if (document.querySelector(".adm-section-c9")) {
    import("./floatingSearch.js");
    import("./floatingSearchMobile.js");
}

if (document.querySelector(".adm-section-c16-stats")) {
    import("./statsSlider.js");
}

if (document.querySelector(".adm-section-c10")) {
    import("./FloatingCards.js");
}

if (document.querySelector(".adm-section-video-carousel")) {
    import("./videoCarousel.js");
}

if (document.querySelector(".adm-section-c17-download")) {
    import("./downloadBlock.js");
}

if (document.querySelector(".adm-section-c29-teaser-floating")) {
    import("./floatingCarouselSlider.js");
}

if (document.querySelector(".adm-section-c25-content")) {
    import("./circleImageSlider.js");
}

if (document.querySelector(".adm-section-c26-header-teaser")) {
    import("./headerTeaserSlider.js");
}

if (document.querySelector(".adm-section-c31-carousel")) {
    import("./lockupIconTeaserCarrousel.js");
}

if (document.querySelector(".adm-section-c41")) {
    import("./jobsComponent.js");
}

if (document.querySelector(".adm-section-c36-pull-quote")) {
    import("./pullQuoteSlider.js");
}

if (document.querySelector(".adm-section-c34-tracker")) {
    import("./interactiveTracker.js");
}

if (document.querySelector(".adm-section-c28-image-carousel-teaser")) {
    import("./imageCarouselTeaserSlider.js");
}

if (document.querySelector(".adm-section-c49-wayfinding")) {
    import("./wayfindingComponent.js");
}

if (document.querySelector(".adm-section-c48-logo-grid")) {
    import("./logoGridSlider.js");
}

if (document.querySelector(".adm-section-c52-contact-widget")) {
    import("./contactUsWidget.js");
}

if (document.querySelector(".adm-section-c59")) {
    import("./productComponent.js");
}

if (document.querySelector(".adm-video-modal")) {
    import("./videoModal.js");
}

if (document.querySelector(".adm-div-c33-form")) {
    import("./contactFormVersion2.js");
}

if (document.querySelector(".adm-section-gateway")) {
    import("./gatewayVersion2.js");
}

if (document.querySelector(".adm-section-c32-popup")) {
    import("./contactTout.js");
}

if (document.querySelector(".adm-div-leadgen-form")) {
    import("./leadGen.js");
}

if (document.querySelector(".adm-section-c61")) {
    import("./headerAndCards.js");
}

if (document.querySelector(".adm-section-c62")) {
    import("./videoModalCards.js");
}

if (document.querySelector(".adm-section-c63")) {
    import("./accordionList.js");
}

if (document.querySelector(".adm-section-c64-wayfinding")) {
    import("./wayfindingComponentv2.js");
}

if (document.querySelector(".adm-section-c65")) {
    import("./headerLogoCardsBlock.js");
}

if (document.querySelector(".adm-section-c66")) {
    import("./infographicHeader.js");
}

if (document.querySelector(".adm-section-c67")) {
    import("./infographicList.js");
}

if (document.querySelector(".adm-section-c68")) {
    import("./faqList.js");
}

if (document.querySelector(".adm-section-c37.mobile-carousel-enabled")) {
    import("./cardCarousel.js");
}

if (document.querySelector(".adm-section-c69")) {
    // Choices.js - Required for Custom Select in Sticky Menu
    import("./stickyMenuChoices.js");

    // Perfect Scrollbar - Required for Sticky Menu Scrollbar
    import("./stickyMenuScrollbar.js");

    // Sticky Menu
    import("./stickyMenu.js");
}

if (document.querySelector(".adm-section-c71")) {
    import("./messageBanner.js");
}

if (document.querySelector(".adm-section-c72")) {
    import("./stickyButton.js");
}

if (document.querySelector(".adm-section-c73")) {
    import("./imageCarouselMenu.js");
}

if (document.querySelector(".adm-section-c74")) {
    import("./headerLogoIconGrid.js");
}

if (document.querySelector(".adm-section-c75")) {
    import("./headerLogoIconVerticalGrid.js");
}